export const getStartDate = (date) => {
  const startDate = new Date(date);
  startDate.setUTCHours(0, 0, 0, 0); // Normalize to midnight UTC
  return startDate.toISOString();
};
